import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.podeConsultar ? _c('div', {
    staticClass: "risco-cliente-grupo"
  }, [_c('button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.top",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "btn btn-primary btn-sm d-inline-flex align-items-center",
    attrs: {
      "type": "button",
      "aria-label": "Consultar inadimplência no grupo",
      "title": "Consultar inadimplência no grupo (F8)"
    },
    on: {
      "click": _vm.abrir
    }
  }, [_c('AccountSearch', {
    attrs: {
      "size": 18
    }
  }), _c('span', {
    staticClass: "ml-2 font-size-xs font-weight-bolder"
  }, [_vm._v("– F8")])], 1), _c('b-modal', {
    ref: "modal",
    attrs: {
      "title": "Visão do cliente no grupo",
      "hide-footer": "",
      "scrollable": "",
      "hide-header-close": false,
      "no-close-on-esc": false,
      "modal-class": "risco-cliente-grupo-modal",
      "dialog-class": "risco-cliente-grupo-dialog",
      "content-class": "risco-cliente-grupo-conteudo"
    },
    on: {
      "hidden": function hidden($event) {
        _vm.empresaDetalheId = null;
      }
    }
  }, [_vm.carregando ? _c('div', {
    staticClass: "text-center py-12"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "primary"
    }
  }), _c('div', {
    staticClass: "text-muted mt-3"
  }, [_vm._v("Consultando o histórico financeiro...")])], 1) : _vm.erro ? _c('b-alert', {
    attrs: {
      "show": "",
      "variant": "light-danger"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center justify-content-between"
  }, [_c('span', [_vm._v(_vm._s(_vm.erro))]), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "danger"
    },
    on: {
      "click": _vm.consultar
    }
  }, [_vm._v(" Tentar novamente ")])], 1)]) : _vm.consulta ? [_c('div', {
    staticClass: "cliente-risco-cabecalho rounded p-4 mb-5"
  }, [_c('div', {
    staticClass: "text-muted font-size-sm"
  }, [_vm._v("Cliente consultado")]), _c('strong', [_vm._v(_vm._s(_vm.consulta.cliente.nome))]), _c('span', {
    staticClass: "text-muted ml-2"
  }, [_vm._v(_vm._s(_vm.formatarDocumento(_vm.consulta.cliente.cnpj_cpf)))]), _c('div', {
    staticClass: "text-muted font-size-sm mt-1"
  }, [_vm._v(_vm._s(_vm.consulta.aviso))])]), _c('b-tabs', {
    attrs: {
      "pills": "",
      "lazy": ""
    },
    on: {
      "input": _vm.aoAlterarAba
    },
    model: {
      value: _vm.abaAtiva,
      callback: function callback($$v) {
        _vm.abaAtiva = $$v;
      },
      expression: "abaAtiva"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Risco financeiro"
    }
  }, [_c('b-row', {
    staticClass: "my-5"
  }, [_c('b-col', {
    staticClass: "mb-4 mb-lg-0",
    attrs: {
      "lg": "3"
    }
  }, [_c('div', {
    staticClass: "score-card h-100 border rounded p-5 text-center"
  }, [_c('div', {
    staticClass: "text-muted text-uppercase font-size-sm"
  }, [_vm._v("Score operacional")]), _c('div', {
    staticClass: "score-valor my-2",
    class: _vm.classeScore(_vm.consulta.score.nivel)
  }, [_vm._v(" " + _vm._s(_vm.consulta.score.valor) + " ")]), _c('span', {
    staticClass: "label label-inline",
    class: _vm.classeLabel(_vm.consulta.score.nivel)
  }, [_vm._v(" " + _vm._s(_vm.consulta.score.descricao) + " ")]), _c('b-progress', {
    staticClass: "mt-4",
    attrs: {
      "height": "8px",
      "value": _vm.consulta.score.valor,
      "max": 1000,
      "variant": _vm.varianteScore(_vm.consulta.score.nivel)
    }
  })], 1)]), _c('b-col', {
    attrs: {
      "lg": "9"
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "sm": "6",
      "xl": "3"
    }
  }, [_c('div', {
    staticClass: "resumo-card border rounded p-4 h-100"
  }, [_c('div', {
    staticClass: "text-muted font-size-sm"
  }, [_vm._v("Total vencido")]), _c('strong', {
    staticClass: "font-size-h4 text-danger"
  }, [_vm._v(" " + _vm._s(_vm.formatarMoeda(_vm.consulta.totais.total_vencido)) + " ")])])]), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "sm": "6",
      "xl": "3"
    }
  }, [_c('div', {
    staticClass: "resumo-card border rounded p-4 h-100"
  }, [_c('div', {
    staticClass: "text-muted font-size-sm"
  }, [_vm._v("Títulos vencidos")]), _c('strong', {
    staticClass: "font-size-h4"
  }, [_vm._v(_vm._s(_vm.consulta.totais.quantidade_vencida))])])]), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "sm": "6",
      "xl": "3"
    }
  }, [_c('div', {
    staticClass: "resumo-card border rounded p-4 h-100"
  }, [_c('div', {
    staticClass: "text-muted font-size-sm"
  }, [_vm._v("Maior atraso")]), _c('strong', {
    staticClass: "font-size-h4"
  }, [_vm._v(" " + _vm._s(_vm.consulta.totais.maior_atraso_dias) + " dias ")])])]), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "sm": "6",
      "xl": "3"
    }
  }, [_c('div', {
    staticClass: "resumo-card border rounded p-4 h-100"
  }, [_c('div', {
    staticClass: "text-muted font-size-sm"
  }, [_vm._v("Empresas afetadas")]), _c('strong', {
    staticClass: "font-size-h4"
  }, [_vm._v(" " + _vm._s(_vm.consulta.totais.empresas_com_inadimplencia) + " ")])])])], 1), _c('div', {
    staticClass: "score-explicacao border rounded px-4 py-3 mt-1 d-flex align-items-center"
  }, [_c('div', [_c('strong', [_vm._v("Score interno")]), _c('span', {
    staticClass: "text-muted font-size-sm ml-2"
  }, [_vm._v("Escala de 0 a 1.000")])]), _c('button', {
    staticClass: "btn btn-icon btn-light-primary btn-sm ml-2",
    attrs: {
      "id": _vm.ajudaScoreId,
      "type": "button",
      "aria-label": "Entenda o cálculo do score"
    }
  }, [_c('InformationOutline', {
    attrs: {
      "size": 17
    }
  })], 1), _c('b-popover', {
    attrs: {
      "target": _vm.ajudaScoreId,
      "triggers": "click blur",
      "placement": "bottom",
      "custom-class": "score-ajuda-popover"
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_vm._v("Como o score foi calculado?")];
      },
      proxy: true
    }], null, false, 3371432885)
  }, [_c('p', {
    staticClass: "font-size-sm mb-2"
  }, [_vm._v(" Começa com 1.000 pontos e diminui conforme a inadimplência do grupo. ")]), _c('ul', {
    staticClass: "font-size-sm pl-4 mb-3"
  }, _vm._l(_vm.consulta.metodologia.regras, function (regra) {
    return _c('li', {
      key: regra
    }, [_vm._v(" " + _vm._s(regra) + " ")]);
  }), 0), _c('div', {
    staticClass: "font-size-sm border-top pt-2"
  }, [_c('strong', [_vm._v("Descontos desta consulta")]), _c('div', [_vm._v("Atraso: -" + _vm._s(_vm.consulta.score.penalidades.atraso))]), _c('div', [_vm._v("Títulos: -" + _vm._s(_vm.consulta.score.penalidades.quantidade))]), _c('div', [_vm._v("Proporção vencida: -" + _vm._s(_vm.consulta.score.penalidades.proporcao))])]), _c('div', {
    staticClass: "font-size-xs text-muted border-top mt-2 pt-2"
  }, [_vm._v(" 0–300 Baixo · 301–500 Regular · 501–700 Bom · 701–1.000 Excelente ")]), _c('div', {
    staticClass: "font-size-xs text-muted mt-2"
  }, [_vm._v(" Análise interna; não representa consulta Serasa, SPC ou Cadastro Positivo. ")])])], 1)], 1)], 1), _c('div', {
    staticClass: "table-responsive border rounded"
  }, [_c('table', {
    staticClass: "table table-head-custom table-vertical-center mb-0"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Empresa")]), _c('th', [_vm._v("Cadastro localizado")]), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Score")]), _c('th', [_vm._v("Status")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Em aberto")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Vencidos")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Total vencido")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Maior atraso")])])]), _c('tbody', [_vm._l(_vm.consulta.empresas, function (item) {
    return [_c('tr', {
      key: "empresa-".concat(item.empresa.id_empresa)
    }, [_c('td', [_c('strong', [_vm._v(_vm._s(item.empresa.nome))])]), _c('td', [item.cliente_localizado ? _vm._l(item.clientes, function (clienteItem) {
      return _c('div', {
        key: clienteItem.id_pessoa
      }, [_vm._v(" " + _vm._s(clienteItem.nome) + " ")]);
    }) : _c('span', {
      staticClass: "label label-inline label-warning"
    }, [_vm._v(" Não cadastrado ")])], 2), _c('td', {
      staticClass: "text-center font-weight-bolder"
    }, [_vm._v(" " + _vm._s(item.score ? item.score.valor : "—") + " ")]), _c('td', [item.score ? _c('span', {
      staticClass: "label label-inline",
      class: _vm.classeLabel(item.score.nivel)
    }, [_vm._v(" " + _vm._s(item.score.descricao) + " ")]) : _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("Sem dados")])]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatarMoeda(item.total_aberto)))]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(item.quantidade_vencida))]), _c('td', {
      staticClass: "text-right font-weight-bold",
      class: item.total_vencido > 0 ? 'text-danger' : ''
    }, [_vm._v(" " + _vm._s(_vm.formatarMoeda(item.total_vencido)) + " ")]), _c('td', {
      staticClass: "text-right text-nowrap"
    }, [_vm._v(" " + _vm._s(item.maior_atraso_dias) + " dias "), item.titulos_vencidos.length ? _c('button', {
      staticClass: "btn btn-link btn-sm py-0 pr-0",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.alternarDetalhes(item.empresa.id_empresa);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.empresaDetalheId === item.empresa.id_empresa ? "Ocultar" : "Ver títulos") + " ")]) : _vm._e()])]), _vm.empresaDetalheId === item.empresa.id_empresa ? _c('tr', {
      key: "detalhes-".concat(item.empresa.id_empresa),
      staticClass: "titulos-detalhes"
    }, [_c('td', {
      staticClass: "p-4",
      attrs: {
        "colspan": "8"
      }
    }, [_c('div', {
      staticClass: "table-responsive bg-white border rounded"
    }, [_c('table', {
      staticClass: "table table-sm mb-0"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Documento")]), _c('th', [_vm._v("Histórico")]), _c('th', [_vm._v("Vencimento")]), _c('th', {
      staticClass: "text-right"
    }, [_vm._v("Valor")])])]), _c('tbody', _vm._l(item.titulos_vencidos, function (titulo) {
      return _c('tr', {
        key: titulo.id
      }, [_c('td', [_vm._v(_vm._s(titulo.documento || "—"))]), _c('td', [_vm._v(_vm._s(titulo.historico || "—"))]), _c('td', [_vm._v(_vm._s(_vm.formatarData(titulo.data_vencimento)))]), _c('td', {
        staticClass: "text-right text-danger font-weight-bold"
      }, [_vm._v(" " + _vm._s(_vm.formatarMoeda(titulo.valor)) + " ")])]);
    }), 0)])])])]) : _vm._e()];
  })], 2)])])], 1), _c('b-tab', {
    attrs: {
      "title": "Sugestões de recompra"
    }
  }, [_vm.carregandoCompras ? _c('div', {
    staticClass: "text-center py-12"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "primary"
    }
  }), _c('div', {
    staticClass: "text-muted mt-3"
  }, [_vm._v("Analisando as compras nas empresas do grupo...")])], 1) : _vm.erroCompras ? _c('b-alert', {
    staticClass: "mt-5",
    attrs: {
      "show": "",
      "variant": "light-danger"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center justify-content-between"
  }, [_c('span', [_vm._v(_vm._s(_vm.erroCompras))]), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "danger"
    },
    on: {
      "click": function click($event) {
        return _vm.consultarCompras(true);
      }
    }
  }, [_vm._v(" Tentar novamente ")])], 1)]) : _vm.compras ? [_c('b-row', {
    staticClass: "mt-5 mb-2"
  }, [_c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "sm": "6",
      "xl": "3"
    }
  }, [_c('div', {
    staticClass: "resumo-card border rounded p-4 h-100"
  }, [_c('div', {
    staticClass: "text-muted font-size-sm"
  }, [_vm._v("Movimentações analisadas")]), _c('strong', {
    staticClass: "font-size-h4"
  }, [_vm._v(" " + _vm._s(_vm.compras.resumo.quantidade_movimentacoes || _vm.compras.resumo.quantidade_compras) + " ")])])]), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "sm": "6",
      "xl": "3"
    }
  }, [_c('div', {
    staticClass: "resumo-card border rounded p-4 h-100"
  }, [_c('div', {
    staticClass: "text-muted font-size-sm"
  }, [_vm._v("Valor concluído")]), _c('strong', {
    staticClass: "font-size-h4"
  }, [_vm._v(" " + _vm._s(_vm.formatarMoeda(_vm.compras.resumo.valor_comprado)) + " ")])])]), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "sm": "6",
      "xl": "3"
    }
  }, [_c('div', {
    staticClass: "resumo-card border rounded p-4 h-100"
  }, [_c('div', {
    staticClass: "text-muted font-size-sm"
  }, [_vm._v("Empresas visitadas")]), _c('strong', {
    staticClass: "font-size-h4"
  }, [_vm._v(" " + _vm._s(_vm.compras.resumo.empresas_com_compras) + " ")])])]), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "sm": "6",
      "xl": "3"
    }
  }, [_c('div', {
    staticClass: "resumo-card border rounded p-4 h-100"
  }, [_c('div', {
    staticClass: "text-muted font-size-sm"
  }, [_vm._v("Última movimentação")]), _c('strong', {
    staticClass: "font-size-h4"
  }, [_vm._v(" " + _vm._s(_vm.formatarData(_vm.compras.resumo.ultima_compra)) + " ")])])])], 1), _c('b-alert', {
    staticClass: "border mb-4",
    attrs: {
      "show": "",
      "variant": "light"
    }
  }, [_vm._v(" O histórico reúne todas as movimentações. Para não contar a mesma negociação mais de uma vez, as sugestões usam somente documentos concluídos ou faturados nos últimos " + _vm._s(_vm.compras.periodo_meses) + " meses. ")]), _vm.compras.sugestoes.length ? _c('div', {
    staticClass: "row"
  }, _vm._l(_vm.compras.sugestoes, function (sugestao) {
    return _c('div', {
      key: _vm.chaveSugestao(sugestao),
      staticClass: "col-xl-6 mb-4"
    }, [_c('div', {
      staticClass: "sugestao-recompra border rounded p-5 h-100"
    }, [_c('div', {
      staticClass: "d-flex justify-content-between align-items-start mb-3"
    }, [_c('div', {
      staticClass: "pr-3"
    }, [_c('strong', {
      staticClass: "font-size-lg"
    }, [_vm._v(" " + _vm._s(sugestao.produto.descricao) + " ")]), _c('div', {
      staticClass: "text-muted font-size-sm"
    }, [_vm._v(" " + _vm._s(_vm.identificacaoProduto(sugestao.produto)) + " ")])]), _c('span', {
      staticClass: "label label-inline text-nowrap",
      class: _vm.classeSituacaoRecompra(sugestao.situacao)
    }, [_vm._v(" " + _vm._s(sugestao.descricao_situacao) + " ")])]), _c('div', {
      staticClass: "font-size-sm mb-3"
    }, [_vm._v(" Comprado "), _c('strong', [_vm._v(_vm._s(sugestao.quantidade_compras) + " vezes")]), _vm._v(", em média a cada "), _c('strong', [_vm._v(_vm._s(sugestao.intervalo_medio_dias) + " dias")]), _vm._v(". ")]), _c('div', {
      staticClass: "recompra-ultima rounded p-3"
    }, [_vm._v(" Há "), _c('strong', [_vm._v(_vm._s(sugestao.dias_desde_ultima_compra) + " dias")]), _vm._v(", o cliente comprou este produto na "), _c('strong', [_vm._v(_vm._s(sugestao.ultima_empresa.nome))]), _vm._v(". ")]), _c('div', {
      staticClass: "d-flex justify-content-between text-muted font-size-sm mt-3"
    }, [_c('span', [_vm._v("Última: " + _vm._s(_vm.formatarData(sugestao.ultima_compra)))]), _c('span', [_vm._v("Previsão: " + _vm._s(_vm.formatarData(sugestao.proxima_compra_estimada)))])])])]);
  }), 0) : _c('b-alert', {
    attrs: {
      "show": "",
      "variant": "light-warning"
    }
  }, [_vm._v(" Ainda não há compras repetidas suficientes para sugerir uma recompra. Consulte a aba “Histórico de compras” para visualizar os itens encontrados. ")])] : _vm._e()], 2), _c('b-tab', {
    attrs: {
      "title": "Histórico de compras"
    }
  }, [_vm.carregandoCompras ? _c('div', {
    staticClass: "text-center py-12"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "primary"
    }
  }), _c('div', {
    staticClass: "text-muted mt-3"
  }, [_vm._v("Buscando as compras do cliente...")])], 1) : _vm.erroCompras ? _c('b-alert', {
    staticClass: "mt-5",
    attrs: {
      "show": "",
      "variant": "light-danger"
    }
  }, [_vm._v(" " + _vm._s(_vm.erroCompras) + " ")]) : _vm.compras ? [_c('div', {
    staticClass: "d-flex flex-wrap align-items-center justify-content-between my-5"
  }, [_c('div', [_c('strong', [_vm._v("Compras nas empresas do grupo")]), _c('div', {
    staticClass: "text-muted font-size-sm"
  }, [_vm._v(_vm._s(_vm.compras.aviso))])]), _c('div', {
    staticClass: "historico-pesquisa mt-3 mt-md-0"
  }, [_c('b-form-input', {
    attrs: {
      "size": "sm",
      "placeholder": "Filtrar produto ou empresa"
    },
    model: {
      value: _vm.filtroHistorico,
      callback: function callback($$v) {
        _vm.filtroHistorico = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "filtroHistorico"
    }
  })], 1)]), _c('div', {
    staticClass: "table-responsive border rounded"
  }, [_c('table', {
    staticClass: "table table-head-custom table-vertical-center mb-0"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Data")]), _c('th', [_vm._v("Empresa")]), _c('th', [_vm._v("Tipo")]), _c('th', [_vm._v("Documento")]), _c('th', [_vm._v("Produto")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Quantidade")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Valor unitário")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Total")])])]), _c('tbody', [_vm._l(_vm.historicoFiltrado, function (item) {
    return _c('tr', {
      key: _vm.chaveHistorico(item)
    }, [_c('td', {
      staticClass: "text-nowrap"
    }, [_vm._v(" " + _vm._s(_vm.formatarData(item.data)) + " "), _c('div', {
      staticClass: "text-muted font-size-xs"
    }, [_vm._v("há " + _vm._s(item.dias_desde) + " dias")])]), _c('td', [_c('strong', [_vm._v(_vm._s(item.empresa.nome))])]), _c('td', [_c('span', {
      staticClass: "label label-inline text-nowrap",
      class: _vm.classeTipoMovimento(item.origem)
    }, [_vm._v(" " + _vm._s(item.tipo) + " ")])]), _c('td', {
      staticClass: "text-nowrap"
    }, [_vm._v(" Nº " + _vm._s(item.numero_documento || item.numero_nota || "—") + " "), _c('div', {
      staticClass: "text-muted font-size-xs"
    }, [_vm._v(" " + _vm._s(item.status ? item.status.descricao : "—") + " ")])]), _c('td', [_c('strong', [_vm._v(_vm._s(item.produto.descricao))]), _c('div', {
      staticClass: "text-muted font-size-xs"
    }, [_vm._v(" " + _vm._s(_vm.identificacaoProduto(item.produto)) + " ")])]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatarQuantidade(item.quantidade)))]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatarMoeda(item.valor_unitario)))]), _c('td', {
      staticClass: "text-right font-weight-bold"
    }, [_vm._v(" " + _vm._s(_vm.formatarMoeda(item.valor_total)) + " ")])]);
  }), !_vm.historicoFiltrado.length ? _c('tr', [_c('td', {
    staticClass: "text-center text-muted py-8",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(" Nenhuma compra encontrada para o filtro informado. ")])]) : _vm._e()], 2)])])] : _vm._e()], 2)], 1)] : _vm._e()], 2)], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };